import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Say Lib
import ColorPicker from "../../ColorPicker";
import ErrorMessage from "../../../Atoms/ErrorMessage";
import withControl from "../../../../hoc/withFormControl";
/**
 * @param control - control from useForm (react-hook-form)
 * @param name - field name
 * @returns JSX.Element
 */
var HookColorPicker = function (_a) {
    var name = _a.name, textFieldProps = _a.textFieldProps, callback = _a.callback, _b = _a.controllerFields, _c = _b.field, value = _c.value, onChange = _c.onChange, errors = _b.formState.errors;
    /**
     * trigger side-effect if needed
     */
    var handleChange = function (color) {
        if (callback) {
            callback(color);
        }
        onChange(color);
    };
    return (_jsxs("div", { children: [_jsx("div", { children: _jsx(ColorPicker, { textFieldProps: textFieldProps, value: value, onChange: handleChange }) }), _jsx(ErrorMessage, { errors: errors, name: name })] }));
};
export { HookColorPicker }; // for react-docgen-typescript
export default withControl(HookColorPicker);
